import { render, staticRenderFns } from "./SectionMenuGeneral.vue?vue&type=template&id=545cfd36&scoped=true&"
import script from "./SectionMenuGeneral.vue?vue&type=script&lang=js&"
export * from "./SectionMenuGeneral.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuGeneral.vue?vue&type=style&index=0&id=545cfd36&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cfd36",
  null
  
)

export default component.exports